import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import hi from "@/locales/hi.json";
import ar from "@/locales/ar.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";
import zh from "@/locales/zh.json";
import ja from "@/locales/ja.json";
import ru from "@/locales/ru.json";
import {
    AGENT_LABEL_POST_PROCESSOR,
    agentLabelPostProcessor,
} from "@/utils/importModuleLabels";

i18n
    .use(LanguageDetector)
    .use(agentLabelPostProcessor)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hi: { translation: hi },
            ar: { translation: ar },
            es: { translation: es },
            fr: { translation: fr },
            de: { translation: de },
            zh: { translation: zh },
            ja: { translation: ja },
            ru: { translation: ru }
        },

        fallbackLng: "en",

        postProcess: [AGENT_LABEL_POST_PROCESSOR],

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;